import { SET_FORMULARIO } from "../actions/types";

const INITIAL_STATE = {
    filtroUsuario: {
        firstName: "",
        lastName: "",
        email: "",
    },
    filtroIniciativa: {
        nombre: "",
        codigo: "",
        estado: "",
    },
};

export default (state = INITIAL_STATE, action) => {
    //console.log("REDUCER FORMULARIO", action);

    switch (action.type) {
        case SET_FORMULARIO:
            //console.log("Respuesta Reducer SET_FORMULARIO", action);
            return {
                ...state,
                [action.payload.campo]: action.payload.valor,
            };
        default:
            return state;
    }
};
